import { Box } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import Toast from 'components/Toast';
import GatherConfirmationSubForm from 'pages/revisions-module/template-editor/editors/pipeline/configurator/properties/GatherConfirmationSubForm';
import PlanNextRevisionSubForm from 'pages/revisions-module/template-editor/editors/pipeline/configurator/properties/PlanNextRevisionSubForm';
import SetRevisionSafetyPointSubForm from 'pages/revisions-module/template-editor/editors/pipeline/configurator/properties/SetRevisionSafetyPointSubForm';
import SetDeviceEvidenceFieldSubForm from 'pages/revisions-module/template-editor/editors/pipeline/configurator/properties/SetDeviceEvidenceFieldSubForm';
import SendEmailSubForm from 'pages/revisions-module/template-editor/editors/pipeline/configurator/properties/SendEmailSubForm';
import SetFileNameSubForm from 'pages/revisions-module/template-editor/editors/pipeline/configurator/properties/SetFileNameSubForm';
import CreateChildDepartmentSubForm from 'pages/revisions-module/template-editor/editors/pipeline/configurator/properties/CreateChildDepartmentSubForm';
import {
  IAutomation,
  IAutomationGatherConfirmation,
  IAutomationPlanNextRevision,
  IAutomationSetDeviceEvidenceField,
  IAutomationSetFileName,
  IAutomationSetRevisionSafetyPoint,
  IAutomationSendEmail,
  IAutomationType,
  IAutomationCreateChildDepartment,
} from 'pages/revisions-module/template-editor/editors/pipeline/types';

type TypeCond<T, U> = [T] extends [never] ? { message: U } : {};

/**
 * Parameters of the AutomationSubForm component.
 */
interface AutomationSubFormProps {
  type: IAutomationType;
  form: UseFormReturnType<IAutomation>;
}

/**
 * Used to configure the type-specific properties of an automation.
 */
export default function AutomationSubForm({ type, form }: AutomationSubFormProps) {
  switch (type) {
    case 'set-revision-safety-point':
      return <SetRevisionSafetyPointSubForm form={form as UseFormReturnType<IAutomationSetRevisionSafetyPoint>} />;

    case 'plan-next-revision':
      return <PlanNextRevisionSubForm form={form as UseFormReturnType<IAutomationPlanNextRevision>} />;

    case 'gather-confirmation':
      return <GatherConfirmationSubForm form={form as UseFormReturnType<IAutomationGatherConfirmation>} />;

    case 'set-device-evidence-field':
      return <SetDeviceEvidenceFieldSubForm form={form as UseFormReturnType<IAutomationSetDeviceEvidenceField>} />;

    case 'send-email':
      return <SendEmailSubForm form={form as UseFormReturnType<IAutomationSendEmail>} />;

    case 'set-file-name':
      return <SetFileNameSubForm form={form as UseFormReturnType<IAutomationSetFileName>} />;

    case 'create-child-department':
      return <CreateChildDepartmentSubForm form={form as UseFormReturnType<IAutomationCreateChildDepartment>} />;

    default:
      // This is a TS trick to make sure all types are handled in the switch.
      // If there is a new type, the compiler will complain here. To fix it, add a new case to the switch.
      const { message }: TypeCond<typeof type, string> = { message: 'Neznámy proces' };

      return (
        <Box mr={32}>
          <Toast fullWidth type="fail" withCloseButton={false} message={message} />
        </Box>
      );
  }
}
